import React from 'react';
import { UploadFlowCarousel } from '../CAV6/UploadFlowCarousel/UploadFlowCarousel';

interface Props {
  onRestartClick: (trigger?: 'online_event' | 'visibilitychange' | 'retry_timer') => void;
  onPauseForWifi?: () => void;
  onResumeFromWifi?: () => void;
}

export const VideoUploadingPage: React.FC<Props> = ({ onRestartClick, onPauseForWifi, onResumeFromWifi }) => {
  return (
    <UploadFlowCarousel
      onIdentitySubmit={async () => true}
      onRestartClick={onRestartClick}
      onPauseForWifi={onPauseForWifi}
      onResumeFromWifi={onResumeFromWifi}
      startAtStep={1}
    />
  );
};
